import React from "react";

interface State {
  height: number;
}

export class PaymentIframe extends React.Component<React.HTMLProps<PaymentIframe>, State> {
  constructor(props) {
    super(props);

    this.state = {
      height: null
    }
  }

  initialize(message: IPaymentInitializeAction) {
    const iframe = this.refs["underlying-iframe"] as HTMLIFrameElement;
    iframe.src = globalConfig.paymentBaseUrl;

    const sendMessage = () => {
      iframe.contentWindow.postMessage(message, globalConfig.paymentBaseUrl);
      iframe.removeEventListener("load", sendMessage);
    };
    iframe.addEventListener("load", sendMessage);

    window.addEventListener("message", event => {
      if (event.origin !== globalConfig.paymentBaseUrl) {
        return;
      }

      const match: string[] = event.data.match(/^([a-zA-z]+)-height:\s([0-9|\.]+)$/);
      if (match) {
        const context: string = match[1];
        const height: number = parseInt(match[2]);

        this.setState({ height });

        // Scroll to the top of the iframe on failure / success / formSubmit
        // so that the iframe contents are definitely in view.
        if (context == 'failure' || context === 'success' || context === 'formSubmit') {
          // Both document.documentElement.scrollTop and document.body.scrollTop need to be used
          // in order for the scrollTop to work across all browsers.
          document.documentElement.scrollTop += iframe.getBoundingClientRect().top - 100;
          document.body.scrollTop += iframe.getBoundingClientRect().top - 100;
        }
      }
    })
  };

  render() {
    return <iframe className={this.props.className} scrolling="true" frameBorder="0" ref="underlying-iframe" width="100%" height={this.state.height} src={globalConfig.paymentBaseUrl} />;
  }
}
